import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import branch from 'client/core/branch';
import { SCREEN_ID_SEARCH_FILTERS } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withApiState from 'client/helpers/withApiState';
import {
  Search as SearchActions,
} from 'client/actions';
import {
  SR_API_ACTION_GET_LISTING_LIST,
} from 'api/actionTypes';

import Navbar from 'client/components/Navbar';
import NavbarButton from 'client/components/NavbarButton';
import SrFormikField from 'client/components/SrFormikField';
import ButtonDeprecated, {
  BUTTON_THEME_BLUE,
} from 'client/components/ButtonDeprecated';

@withTransitionHook
@withScreenId(SCREEN_ID_SEARCH_FILTERS)
@withScrollToTop
@withApiState({
  resultsCountApiState: {
    action: SR_API_ACTION_GET_LISTING_LIST,
  },
})
@branch({
  searchFilters: ['search', 'filters'],
  resultsCount: ['search', 'resultsCount'],
})
class FilterSquareFeetRangePage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Sunroom Rentals',
    section: 'Search Filters',
  })

  static propTypes = {
    searchFilters: PropTypes.object.isRequired,
    resultsCount: PropTypes.number,
    resultsCountApiState: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);

    const { searchFilters } = props;

    this.state = {
      minSquareFeet: searchFilters.minSquareFeet,
      maxSquareFeet: searchFilters.maxSquareFeet,
    };
  }

  _onChangeSquareFeet = (filterKey, filterValue) => {
    const updates = {
      [filterKey]: filterValue || null,
    };

    this.setState(updates);

    if (this._isValidForm({ ...this.state, ...updates })) {
      this.props.dispatch(SearchActions.updateFilter, {
        filterKey,
        filterValue: filterValue || null,
      });
    }
  }

  _isValidForm = ({ minSquareFeet, maxSquareFeet }) => {
    return (
      !minSquareFeet && maxSquareFeet
      || minSquareFeet && !maxSquareFeet
      || maxSquareFeet > minSquareFeet
    );
  }

  _onSubmit = () => {
    const { history } = this.props;
    history.push('/search');
  }

  render() {
    const {
      history,
      resultsCountApiState,
      resultsCount,
    } = this.props;
    const { minSquareFeet, maxSquareFeet } = this.state;

    return (
      <div className='modal specificFilter'>
        <div className='squareFeetRange'>
          <div className='modal filters specificFilter'>
            <Navbar
              leftButton={(
                <NavbarButton onClick={() => history.push('/search')}>
                  Cancel
                </NavbarButton>
              )}
            />
            <div className='contentContainer'>
              <span className='headline'>Square Feet</span>

              <div className='values'>
                <SrFormikField
                  formField={{
                    id: 'minSquareFeet',
                    title: 'Min.',
                    properties: {
                      placeholder: 'min. sqft',
                      pattern: '[0-9]*',
                      onChange: (newValue) => {
                        this._onChangeSquareFeet('minSquareFeet', newValue);
                      },
                    },
                    type: 'numberWithComma',
                  }}
                  value={minSquareFeet}
                />
                <SrFormikField
                  formField={{
                    id: 'maxSquareFeet',
                    title: 'Max.',
                    properties: {
                      placeholder: 'max. sqft',
                      pattern: '[0-9]*',
                      onChange: (newValue) => {
                        this._onChangeSquareFeet('maxSquareFeet', newValue);
                      },
                    },
                    type: 'numberWithComma',
                  }}
                  value={maxSquareFeet}
                />
              </div>

              <div className='saveFilterContainer'>
                <ButtonDeprecated
                  theme={BUTTON_THEME_BLUE}
                  onClick={this._onSubmit}
                  disabled={!this._isValidForm({ minSquareFeet, maxSquareFeet })}
                >
                  {resultsCountApiState.isLoading
                    ? 'please wait...'
                    : (typeof resultsCount === 'number'
                      ? `done (${resultsCount} ${pluralize('match', resultsCount)})`
                      : 'done'
                    )
                  }
                </ButtonDeprecated>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FilterSquareFeetRangePage.displayName = 'FilterSquareFeetRangePage';

export default FilterSquareFeetRangePage;
